import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@mdi/font/css/materialdesignicons.css'
import de from 'vuetify/src/locale/de.ts'
import en from 'vuetify/src/locale/en.ts'

Vue.use(Vuetify, {
	methods: {
		changeLocale(locale) {
			this.$vuetify.lang.current = locale
		},
	},
	data() {
		return {}
	},
})

export default new Vuetify({
	theme: {
		dark: false,
	},
	icons: {
		iconfont: 'mdi',
	},
	lang: {
		locales: { en, de },
		current: 'en',
	},
})
